/**
 * Created by Kaku.Guo on 2018/10/29.
 */
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { AssetActions, ReviewActions } from '../actions';
import { AssetApi } from '../apis';

const getLoggedInState = state => state.get('user').get('isLoggedIn');

function* listAssets(action) {
    try {
        const params = action.payload;
        const data = yield call(AssetApi.listAssets, params);
        yield put(AssetActions.listAssetsSuccess(data));
    } catch (e) {
        yield put(AssetActions.listAssetsFailed(e));
    }
}

function* suggestAssets(action) {
    try {
        const params = action.payload;
        const data = yield call(AssetApi.suggestAssets, params);
        yield put(AssetActions.suggestAssetsSuccess(data));
    } catch (e) {
        yield put(AssetActions.suggestAssetsFailed(e));
    }
}

function* vaultAssets(action) {
    try {
        const params = action.payload;
        const data = yield call(AssetApi.vaultAssets, params);
        yield put(AssetActions.vaultAssetsSuccess(data));
    } catch (e) {
        yield put(AssetActions.vaultAssetsFailed(e));
    }
}

function* getHomeData() {
    try {
        const data = yield call(AssetApi.getHomeData);
        yield put(AssetActions.getHomeDataSuccess(data));
    } catch (e) {
        yield put(AssetActions.getHomeDataFailed(e));
    }
}

function* getAsset(action) {
    try {
        const { slug, isItem } = action.payload;
        let data;
        if (isItem) {
            data = yield call(AssetApi.getItem, slug);
        } else {
            data = yield call(AssetApi.getAsset, slug);
        }
        yield put(AssetActions.getAssetSuccess(data));
        const isLoggedIn = yield select(getLoggedInState);
        const { data: { id, customAttributes } } = data;
        const hasBuyLink = customAttributes && 'BuyLink' in customAttributes;
        if (id && !hasBuyLink) {
            if (isLoggedIn) { // getReviewDetailByAccount
                yield put(ReviewActions.getReviewDetailByAccount({ offerId: id }));
            } else {
                yield put(ReviewActions.getReviewDetailByAccountSuccess({}));
            }
        }
        if (id) {
            yield put(ReviewActions.getRating({ offerId: id }));
        }
    } catch (e) {
        yield put(AssetActions.getAssetFailed(e));
    }
}

function* sellerAssets(action) {
    try {
        const data = yield call(AssetApi.sellerAssets, action.payload);
        yield put(AssetActions.sellerAssetsSuccess(data));
    } catch (e) {
        yield put(AssetActions.sellerAssetsFailed(e));
    }
}

function* getHelmet(action) {
    try {
        const { slug, isItem } = action.payload;
        let data;
        if (isItem) {
            data = yield call(AssetApi.getItem, slug);
        } else {
            data = yield call(AssetApi.getAsset, slug);
        }
        yield put(AssetActions.getHelmetSuccess(data));
    } catch (e) {
        yield put(AssetActions.getHelmetFailed(e));
    }
}

function* AssetSaga() {
    yield takeLatest(AssetActions.TYPES.LIST_ASSETS_PENDING, listAssets);
    yield takeLatest(AssetActions.TYPES.SUGGEST_ASSETS_PENDING, suggestAssets);
    yield takeLatest(AssetActions.TYPES.VAULT_ASSETS_PENDING, vaultAssets);
    yield takeLatest(AssetActions.TYPES.GET_HOME_DATA_PENDING, getHomeData);
    yield takeLatest(AssetActions.TYPES.GET_ASSET_PENDING, getAsset);
    yield takeLatest(AssetActions.TYPES.GET_HELMET_PENDING, getHelmet);
    yield takeLatest(AssetActions.TYPES.SELLER_ASSETS_PENDING, sellerAssets);
}

export default AssetSaga;